import type { RobotSummary } from './RobotSummary';

export enum StatusEnum {
  OKAY = 'okay',
  NOT_OKAY = 'not_okay',
  DEPLOYING = 'deploying',
  DECOMMISSIONED = 'decommissioned',
}

export interface AdminRobot extends RobotSummary {
  internalNotes: string;
  internalName?: string;
  status: StatusEnum;
  cellUuid?: string;
  cellName?: string;
  customerName?: string;
}

export interface NewAdminRobot {
  name: string;
  serialNumber: string;
  internalNotes?: string;
  internalName?: string;
  status: StatusEnum;
  cellUuid?: string;
}

export const EMPTY_NEW_ADMIN_ROBOT: NewAdminRobot = {
  name: '',
  serialNumber: '',
  status: StatusEnum.OKAY,
};
